import React, { useEffect, useState } from 'react';
import { FaUser, FaBriefcase, FaFileExcel, FaTasks, FaEnvelope, FaStar } from 'react-icons/fa';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Typography, Button, Grid } from '@mui/material';
import Paper from '@mui/material/Paper';
import { Link, useHistory } from 'react-router-dom';
import { CSVLink } from 'react-csv';

import { supabase } from "../../supabaseClient";

export default function Students({ students, showCompany }) {
  const history = useHistory();
  const [csvData, setCsvData] = useState([]);

  const handleStudentClick = (studentId) => {
    console.log(`Haz clic en el estudiante con ID ${studentId}`);
    history.push(`/admin/students/${studentId}`);
  };

  const handleEditStudent = (studentId) => {
    console.log(`Haz clic en el botón de editar para el estudiante con ID ${studentId}`);
    history.push(`/admin/students/${studentId}/edit`);
  };

  useEffect(() => {
    if (students) {
      console.log(students)
      setCsvData(students.map((student) => ({
        Nombre: student.name,
        Puntos: student.score,
        Correo: student.email,
      })));
    }
  }, [students]);

  return (
    <>
      <Paper
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 240,
        }}
      >
        <Typography>Estudiantes</Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Nombre</TableCell>
              {showCompany && <TableCell align="right">Empresa</TableCell>}
              <TableCell align="right">Puntaje</TableCell>
              <TableCell align="right">Actividades</TableCell>
              <TableCell align="right"><FaEnvelope style={{ marginRight: '0.5rem' }} /> Correo</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {students && students.map((student) => (
              <TableRow
                key={student.id}
                onClick={() => handleStudentClick(student.id)}
                style={{ cursor: 'pointer' }}
              >
                <TableCell>
                  <FaUser style={{ marginRight: '0.5rem' }} />
                  {student.name}
                </TableCell>
                {showCompany && (
                  <TableCell align="right">
                    <FaBriefcase style={{ marginRight: '0.5rem' }} />
                    {student.company.name}
                  </TableCell>
                )}
                <TableCell align="right">
                  <FaStar style={{ marginRight: '0.5rem' }} />
                  {student.score}
                </TableCell>
                <TableCell align="right">
                  {student.user_activities.length}
                </TableCell>
                <TableCell align="right">
                  <a href={`mailto:${student.email}`}>{student.email}</a>
                </TableCell>
              </TableRow>
            ))}
            {students?.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography variant="h5" color="textSecondary">
                    Aun no hay usuarios 🔍
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {students?.length > 0 && (
          <Grid container justifyContent="flex-start" sx={{ marginTop: '1rem' }}>
            <Grid item>
              <Button
                variant="contained"
                color="success"
                size="small"
                startIcon={<FaFileExcel />}
                sx={{ backgroundColor: 'green', color: '#fff' }}
              >
                <CSVLink data={csvData} filename="estudiantes.csv" style={{ color: '#fff', textDecoration: 'none' }}>
                  Exportar a Excel
                </CSVLink>
              </Button>
            </Grid>
          </Grid>
        )}
      </Paper>
    </>
  );
}
